// Where the panel sits over the map, in px. SubregionMap moves the zoom control clear of it.
export const PANEL_INSET = 8;
export const PANEL_WIDTH = 340;
// How long the panel takes to slide in. SubregionMap moves the zoom control in step.
export const PANEL_SLIDE_MS = 200;
